import { useRoutes, useNavigate, useLocation } from 'react-router-dom';

import { protectedRoutes } from './protected';

export const AppRoutes = () => {
  const navigate = useNavigate();


  const routes = protectedRoutes;

  const element = useRoutes([...routes]);
  return element;
};
